
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserOrg } from "@/types/subscription";

interface OrganizationSelectorProps {
  userOrgs: UserOrg[];
  selectedOrgId: string;
  setSelectedOrgId: (orgId: string) => void;
}

export const OrganizationSelector = ({
  userOrgs,
  selectedOrgId,
  setSelectedOrgId
}: OrganizationSelectorProps) => {
  if (userOrgs.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col items-center justify-center mb-6">
      <p className="text-gray-600 mb-2">Sélectionnez l'organisation à mettre à jour :</p>
      <Select value={selectedOrgId} onValueChange={setSelectedOrgId}>
        <SelectTrigger className="w-64">
          <SelectValue placeholder="Sélectionner une organisation" />
        </SelectTrigger>
        <SelectContent>
          {userOrgs.map((org) => (
            <SelectItem key={org.id} value={org.id}>
              {org.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
};
